import {
    formatCurrencyInputOnChange,
    formatCurrencyInputOnChangeWithoutDecimals,
} from '@fruitful/fruitils';
import React, { forwardRef } from 'react';
import { type Input as BaseInput } from 'tamagui';

import { Input, type InputProps } from './Input';

export interface DollarInputProps extends Omit<
    InputProps,
    'onChangeText' | 'value'
> {
    value?: string;
    onChangeText?: (formattedValue: string) => void;
    allowDecimals?: boolean;
}

export const DollarInput = forwardRef<BaseInput, DollarInputProps>(
    (
        {
            value = '',
            onChangeText,
            placeholder = '$',
            inputMode = 'decimal',
            keyboardType = 'decimal-pad',
            autoComplete = 'off',
            allowDecimals = true,
            ...props
        },
        ref,
    ) => {
        const handleChangeText = (text: string) => {
            const previousValue = value || '$ ';
            const formattedValue = allowDecimals
                ? formatCurrencyInputOnChange(previousValue, text)
                : formatCurrencyInputOnChangeWithoutDecimals(
                      previousValue,
                      text,
                  );
            onChangeText?.(formattedValue);
        };

        return (
            <Input
                ref={ref}
                value={value}
                onChangeText={handleChangeText}
                placeholder={placeholder}
                inputMode={inputMode}
                keyboardType={keyboardType}
                autoComplete={autoComplete}
                {...props}
            />
        );
    },
);
